import { Component, OnInit, OnDestroy} from '@angular/core';
import { Log } from '../utils/log';
import { CSSMonitorService } from '../services/css-monitor.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

declare var $:any;
/**
 * This class represents the toolbar component.
 */
@Component({
    selector: 'toolbar',
    templateUrl: 'toolbar.component.html',
    standalone: false
})

export class ToolbarComponent implements OnInit, OnDestroy {

	public currentLanguage:string = 'English (U.S./U.K.)';
	public flagSrc:string;
	public user: any = null;
	public cssDisabled:boolean = false;

	private _USFLAG = 'assets/images/flags/usUkFlag.png';
	private _FRFLAG = 'assets/images/flags/franceFlag.png';
	private _SPFLAG = 'assets/images/flags/mexicoFlag.png';
	private subscription: Subscription = null;

	constructor(
		private translate: TranslateService,
		private cssMonitorService: CSSMonitorService
	) { }

	ngOnInit(): void {
		this.translate.setDefaultLang('en');
		this.setLanguage(this.translate.getBrowserLang());

        this.cssMonitorService.start();
        this.subscription = this.cssMonitorService.styleChangeEvent.subscribe(
			(gotCss:string) => {
				if (gotCss === this.cssMonitorService.CSS_DISABLED) {
					this.handleCSSDisabled();
				} else {
					this.handleCSSEnabled();
				}
			}
		);

		// when language changes reset the language dropdown
		this._updateLanguageSelection(this.translate.currentLang);
		this.translate.onLangChange.subscribe((event : any) =>{
			this._updateLanguageSelection(event.lang);
		});
	}

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

	setLanguage(langCode:string): void {
		this.translate.use(langCode).subscribe(
			res => {
				// do nothing
			},
			error => {
				Log.warning('The language: ' + langCode + ' could not be found.', error);
				langCode = 'en';
				this.translate.use(langCode);
			}
		);

		if(langCode === 'fr') {
			this.currentLanguage = 'French';
			this.flagSrc = this._FRFLAG;
		} else if (langCode === 'es') {
			this.currentLanguage = 'Spanish';
			this.flagSrc = this._SPFLAG;
		} else {
			this.currentLanguage = 'English (U.S./U.K.)';
			this.flagSrc = this._USFLAG;
		}
	}

	gotoTTP() {
		let ttpURL = environment.uriTTPEndpoint.replace("api/", "");
		window.location.href = ttpURL;
	}

    protected handleCSSDisabled() {
		this.cssDisabled = true;
		
	}

	protected handleCSSEnabled() {
		this.cssDisabled = false;
		//let menuBtn = document.getElementById('languageMenu');
		////console.log(menuBtn);
		$("#languageMenu").css("list-style", "none");
		////console.log(menuBtn);
	}

	private _updateLanguageSelection(langCode: string) {
		if(langCode === 'fr'){
			this.currentLanguage = "FRANÇAIS";
			this.flagSrc = this._FRFLAG;
		}
		else if (langCode === 'es'){
			this.currentLanguage = "ESPAÑOL";
			this.flagSrc = this._SPFLAG;
		}
		else{
			this.currentLanguage = "English (U.S./U.K.)";
			this.flagSrc = this._USFLAG;
		}
	}

}
